import {IntegrationMode} from './integration-mode.model';
import {GroupedValidationRuleWithStat} from './validation-rule-with-stat.model';

export class AggregatedValidationInfoModel {
    constructor(
        public rosterType: string = null,
        public integrationId: string = null,
        public integrationMode: IntegrationMode = null,
        public invalidEntitiesCount: number = 0,
        public skippedEntitiesCount: number = 0
    ) { }
}

export class AggregatedValidationData {
    constructor(
        public invalidEntitiesCount: number = 0,
        public skippedEntitiesCount: number = 0
    ) { }
}

export class GroupedAggregatedValidationInfo {
    [key: string]: AggregatedValidationData;
}

export class GroupedAggregatedValidationInfoByIntegrationMode {
    constructor(
        public key: IntegrationMode = null,
        public groupedStat: GroupedAggregatedValidationInfo = null
    ) { }
}

export class AggregatedValidationStatsByRosterType {
    constructor(
        public rosterType: string = '',
        public data: AggregatedValidationData = null
    ) { }
}
